// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-label[data-v-2212668c] {\n  display: inline-block;\n  padding: 0 5px;\n  color: #666666;\n}\n", ""]);
// Exports
module.exports = exports;
